// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._19itglyw{border:none}\n._2rko12b0{border-radius:var(--ds-radius-small,4px)}._12vemgnk{background-repeat:no-repeat}\n._16qszp5g{box-shadow:inset 0 0 0 2px var(--ds-border-selected,#1868db)}\n._1bsb1ady{width:44px}\n._1lrw1dfr{background-size:cover}\n._4t3i1ylp{height:40px}\n._kqswh2mm{position:relative}\n._ouxl1ssb{background-position:50%}", ""]);
// Exports
module.exports = exports;
